import { mapperPermissionsList } from 'utils/permissions';

const FilterSchema = {
    userName: {
        dataType: 'text',
        description: 'cfm_label_name',
        id: 'userName',
    },
    externalId: {
        dataType: 'text',
        description: 'cfm_label_external_id',
        id: 'extId',
    },
    userEmail: {
        dataType: 'text',
        description: 'cfm_label_email',
        id: 'userEmail',
    },
    userPhone: {
        dataType: 'text',
        description: 'cfm_label_mobile',
        id: 'userPhone',
    },
    userEnvironment: {
        dataType: 'text',
        description: 'cfm_label_home_environment',
        id: 'userEnvironment',
    },
    responsibleName: {
        dataType: 'text',
        description: 'cfm_label_responsible',
        id: 'responsibleName',
    },
    isActive: {
        dataType: 'singleValueList',
        description: 'cfm_label_users_status',
        id: 'isActive',
        options: 'isActiveOptions',
    },

    // isBillable
};

export default class UsersManager {
    constructor(api) {
        this.api = api;
    }

    getFilterSchema = () => FilterSchema;

    getImplSummary = () => this.api.getImplSummary();

    getUsersHierachy = () => this.api.getUsersHierachy();

    getUser = (id) => this.api.getUser(id);

    getUserPermissions = (userId) =>
        this.api.getUserPermissions(userId).then((res) => {
            const result = mapperPermissionsList(res);
            return result;
        });

    toggleActivateUser = (id, isUserActive) =>
        this.api.toggleActivateUser(id, {
            isUserActive,
        });

    getPasswordPolicies = () => this.api.getPasswordPolicies();

    getSSOProvider = () => this.api.getSSOProvider();

    getUserSchema = () => this.api.getCrudSchema('tblUsuarios');

    deleteUser = (id) => this.api.deleteUser(id);

    sendEmailPassword = (id) => this.api.sendEmailPassword(id);

    getCountryCodes = () => this.api.getCountryCodes();
}
